import React from 'react';
import { MapPin, Bike, Castle, Trees, Ship, GlassWater } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { attractions } from '../data/mock';

const Attractions = () => {
  const attractionIcons = [Bike, Castle, Trees, MapPin, Ship, GlassWater];

  return (
    <section id="attractions" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Výlety v okolí
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Objevte krásy jižní Moravy a okolí našeho kempu
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {attractions.map((attraction, index) => {
            const Icon = attractionIcons[index % attractionIcons.length];
            
            return (
              <Card
                key={index}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-gray-100 hover:border-emerald-300"
              >
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="bg-emerald-100 rounded-full p-3 group-hover:bg-emerald-600 transition-colors flex-shrink-0">
                      <Icon className="w-6 h-6 text-emerald-600 group-hover:text-white transition-colors" />
                    </div>
                    <div className="flex-1">
                      <p className="text-gray-900 font-medium leading-relaxed">
                        {attraction}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-2xl p-8 md:p-12 text-white shadow-2xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-4">
                Vinařská oblast jižní Moravy
              </h3>
              <p className="text-emerald-100 text-lg leading-relaxed mb-6">
                Náš kemp se nachází v krásné vinařské oblasti, pouhých 10 km od Hodonína. 
                Ideální výchozí bod pro cykloturistiku, návštěvy vinných sklepů a poznávání 
                folklórních tradic Slovácka.
              </p>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span className="text-emerald-50">10 km od Hodonína</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span className="text-emerald-50">Cyklostezky v okolí</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span className="text-emerald-50">Vinné sklípky a degustace</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-300 rounded-full"></div>
                  <span className="text-emerald-50">Folklórní tradice Slovácka</span>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://i.ibb.co/m3rRG3p/IMG-20260408-WA0010.jpg"
                alt="Okolí kempu"
                className="rounded-xl shadow-2xl w-full h-80 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Attractions;
